import { render, staticRenderFns } from "./TalkIcon.vue?vue&type=template&id=19a5adac&"
import script from "./TalkIcon.vue?vue&type=script&lang=js&"
export * from "./TalkIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports